export default {
  falm: '免费取览法律信息',
  hklii23: '香港法律资讯中心 2023',
  banner_text: 'HKLII 感谢我们的赞助者支持「<b>免费取览法律资讯：香港法律资讯中心 2023</b>」活动！ ',
  banner_btn: '赞助者',
  intro: "<p>二十多年来，HKLII 一直在香港免费提供法律信息。 没有您的慷慨赞助，我们无法继续我们的工作。</p><p>许多机构和人士为 HKLII 提供了宝贵的资金支持我们继续发展。 以下列出的 HKLII 发起人将按英文字母顺序排列。</p> <p>我们衷心感谢您对 HKLII 的赞助和支持。</p>",
  sponsorcall: '赞助香港法律资讯中心',
  sponsorintro: '我们诚邀您从现在至 2023 年 12 月 31 日赞助「免费取览法律资讯：香港法律资讯中心 2023」，条款如下：',
  term_recog_long: '在香港法律资讯中心网站鸣谢赞助：',
  term_recog_short: '在香港法律资讯中心网站鸣谢赞助',
  term_name: '公司名称附超连结到赞助者的网站',
  term_logo: '公司标志（{0}）附超连结到赞助者的网站',
  term_logo_l: '大',
  term_logo_m: '中',
  term_logo_s: '小',
  term_promo: '在其他宣传资料（例如活动单张）显示公司名称/标志',
  tier_diamond: '钻石赞助',
  tier_diamond_amt: '港币 5 万元或以上',
  tier_platinum: '白金赞助',
  tier_platinum_amt: '港币 3 万元至港币 49,999 元',
  tier_gold: '金赞助',
  tier_gold_amt: '港币 1 万元至港币 29,999 元',
  tier_other: '其他赞助',
  tier_other_amt: '港币 1 万元以下',
  tax_deduction: '根据《税务条例》第 88 条，赞助「免费取览法律资讯：香港法律资讯中心 2023」，与向香港大学提供的其他捐款一样，均可申请扣除税项。 ',
  donateonline: '线上捐款',
  cheque_title: '支票捐款',
  cheque_text: '请将写有「香港大学」为抬头的支票邮寄给李秀雯女士，我们的办公室地址是：',
  cheque_addr: '香港薄扶林道<br/>香港大学<br/>郑裕彤教学楼10楼',
  enquire: '如需查询，欢迎以电邮联系李秀雯女士 (<a href="mailto:lirachel@hku.hk">lirachel@hku.hk</a>)。 ',
}